import { createListenerMiddleware } from '@reduxjs/toolkit';

export const creatorListenerMiddleware = createListenerMiddleware();
